import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'

export type ApiTokenAbility = 'news:read' | 'news:write'

export const API_TOKEN_ABILITIES: ApiTokenAbility[] = ['news:read', 'news:write']

export interface ApiToken {
  id: number
  name: string
  abilities: ApiTokenAbility[]
  last_used_at: string | null
  expires_at: string | null
  revoked_at: string | null
  created_at: string | null
}

export interface ApiTokenCreateInput {
  name: string
  abilities: ApiTokenAbility[]
  expires_at?: string | null
}

export const apiTokensApi = {
  getList: async (): Promise<ApiToken[]> => {
    const response = await apiClient.get<{ data: ApiToken[] }>(API_ENDPOINTS.ADMIN.API_TOKENS.LIST)
    return response.data.data
  },

  /** Выпуск токена: plaintext (`token`) приходит ровно один раз */
  create: async (body: ApiTokenCreateInput): Promise<{ token: string; data: ApiToken }> => {
    const response = await apiClient.post<{ message: string; token: string; data: ApiToken }>(
      API_ENDPOINTS.ADMIN.API_TOKENS.LIST,
      body,
    )
    return { token: response.data.token, data: response.data.data }
  },

  revoke: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.ADMIN.API_TOKENS.ITEM(id))
  },
}
